'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = undefined;

var _react = require('react');

var defaultProps = exports.defaultProps = {
  prefixCls: 'rc-progress',
  strokeWidth: 1,
  strokeColor: '#2db7f5',
  trailWidth: 1,
  trailColor: '#D9D9D9',
  strokeLinecap: 'round',
  className: ''
};

var propTypes = exports.propTypes = {
  prefixCls: _react.PropTypes.string,
  strokeWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  strokeColor: _react.PropTypes.string,
  trailWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  trailColor: _react.PropTypes.string,
  strokeLinecap: _react.PropTypes.oneOf(['round', 'square']),
  style: _react.PropTypes.object,
  className: _react.PropTypes.string
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.0.2@rc-progress/lib/props.js
 ** module id = 174
 ** module chunks = 0
 **/